/**
 * pages.config.js - Page routing configuration
 * 
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 * 
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 * 
 * Example file structure:
 * 
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *   
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *   
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 * 
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import AssinaturaPlano from './pages/AssinaturaPlano';
import ActivityLog from './pages/ActivityLog';
import Agenda from './pages/Agenda';
import Analise from './pages/Analise';
import AtestadosTecnicos from './pages/AtestadosTecnicos';
import ConfiguracaoEmpresa from './pages/ConfiguracaoEmpresa';
import { lazy } from 'react';
import { lazyImportModule } from '@/lib/lazyWithRetry';

/** Code-split: rotas pesadas em chunks próprios (menos JS no primeiro paint). */
const ConsultarEditais = lazy(() => lazyImportModule(() => import('./pages/ConsultarEditais.jsx')));
const Upload = lazy(() => lazyImportModule(() => import('./pages/Upload.jsx')));
const VisualizarContrato = lazy(() => lazyImportModule(() => import('./pages/VisualizarContrato.jsx')));
const Social = lazy(() => lazyImportModule(() => import('./pages/Social.jsx')));
const Pulse = lazy(() => lazyImportModule(() => import('./pages/Pulse.jsx')));
const Empresas = lazy(() => lazyImportModule(() => import('./pages/Empresas.jsx')));
const DashboardComercial = lazy(() => lazyImportModule(() => import('./pages/DashboardComercial.jsx')));
const CriarAtestado = lazy(() => lazyImportModule(() => import('./pages/CriarAtestado.jsx')));
const AtestadosDeclaracoes = lazy(() => lazyImportModule(() => import('./pages/AtestadosDeclaracoes.jsx')));
const Resultados = lazy(() => lazyImportModule(() => import('./pages/Resultados.jsx')));
import Contratos from './pages/Contratos';
import CriarAditivo from './pages/CriarAditivo';
import CriarOrdemServico from './pages/CriarOrdemServico';
import CriarContrato from './pages/CriarContrato';
import CriarProposta from './pages/CriarProposta';
import Dashboard from './pages/Dashboard';
import Documentos from './pages/Documentos';
import Assina from './pages/Assina';
import AuctionCertify from './pages/AuctionCertify';
import Suporte from './pages/Suporte';
import ForecastContratos from './pages/ForecastContratos';
import Historico from './pages/Historico';
import Home from './pages/Home';
import LearnedLessons from './pages/LearnedLessons';
import Manifesto from './pages/Manifesto';
/** Code-split: Kanban + queries pesadas em chunk próprio (ver também comentário em lazy acima). */
const Licitacao = lazy(() => lazyImportModule(() => import('./pages/Licitacao.jsx')));
import PRD from './pages/PRD';
import Propostas from './pages/Propostas';
import StatusReport from './pages/StatusReport';
import SyncKanbanConfig from './pages/SyncKanbanConfig';
import VisualizarProposta from './pages/VisualizarProposta';
import Uso from './pages/Uso';
import Faturas from './pages/Faturas';
import __Layout from './Layout.jsx';


export const PAGES = {
    "AssinaturaPlano": AssinaturaPlano,
    "ActivityLog": ActivityLog,
    "Agenda": Agenda,
    "Analise": Analise,
    "AtestadosDeclaracoes": AtestadosDeclaracoes,
    "AtestadosTecnicos": AtestadosTecnicos,
    "ConfiguracaoEmpresa": ConfiguracaoEmpresa,
    "ConsultarEditais": ConsultarEditais,
    "Contratos": Contratos,
    "CriarAditivo": CriarAditivo,
    "CriarOrdemServico": CriarOrdemServico,
    "CriarAtestado": CriarAtestado,
    "CriarContrato": CriarContrato,
    "CriarProposta": CriarProposta,
    "Dashboard": Dashboard,
    "Documentos": Documentos,
    "Assina": Assina,
    "AuctionCertify": AuctionCertify,
    "Suporte": Suporte,
    "Empresas": Empresas,
    "ForecastContratos": ForecastContratos,
    "Historico": Historico,
    "Home": Home,
    "LearnedLessons": LearnedLessons,
    "Manifesto": Manifesto,
    "Licitacao": Licitacao,
    "PRD": PRD,
    "Propostas": Propostas,
    "Relatorios": DashboardComercial,
    "Resultados": Resultados,
    "StatusReport": StatusReport,
    "SyncKanbanConfig": SyncKanbanConfig,
    "Upload": Upload,
    "VisualizarContrato": VisualizarContrato,
    "VisualizarProposta": VisualizarProposta,
    "Uso": Uso,
    "Faturas": Faturas,
    "Social": Social,
    "Pulse": Pulse,
}

export const pagesConfig = {
    mainPage: "Dashboard",
    Pages: PAGES,
    Layout: __Layout,
};